import axios from '@/utils/axios'
import store from '@/store'
export function record (transactionIdList, description, type) {
  return axios({
    url: '/diary',
    method: 'post',
    data: {
      transaction_id_list: transactionIdList,
      username: store.getters['user/username'],
      transaction_type: type,
      description: description,
      time: getFormatCurentDate()
    }
  })
}

export function getFormatCurentDate () {
  var date = new Date()
  console.log(date.getMonth())
  var month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  var year = date.getFullYear()
  var day = date.getDate() > 10 ? date.getDate() : '0' + date.getDate()
  return year + '-' + month + '-' + day
}

export function formatCurrencyNumber (number, digits = 3, delimiter = ',') {
  var re = new RegExp(`(\\d)(?=(\\d{${digits}})+(?:\\.\\d+)?$)`, 'g')
  return String(number).replace(re, `$1${delimiter}`)
}

export function shallowCopy (obj) {
  if (typeof obj === 'object') {
    return JSON.parse(JSON.stringify(obj))
  }
  return false
}

export function formatDateDash (str) {
  if (str === undefined || !str.length) return ''
  str = str.replace(/-/g, '')
  return str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6)
}

export function parseFloat (num, fix = 2) {
  return Number(num.toFixed(fix))
}

export function capitalize (str) {
  if (typeof str !== 'string' || str.trim() === '') return null
  return str[0].toUpperCase() + str.slice(1)
}

export function calcCurrencyRate (curr) {
  let rate = Number(curr)
  if (rate > 100) rate = rate / 100
  return rate.toFixed(2)
}

export function genNmInvoice () {
  // 2018/12/31 23:59:59 GMT epoch timestamp
  const baseTimeStamp = 1546300799
  const now = Math.floor(Date.now() / 1000)

  return Math.floor((now - baseTimeStamp) / 60)
}

export function convertToServerTimeZone (timestamp) {
  const offset = -5.0
  let clientDate = new Date(timestamp * 1000)
  let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)

  let serverDate = new Date(utc + (3600000 * offset))

  return serverDate.getFullYear() + '-' + (serverDate.getMonth() + 1) + '-' + serverDate.getDate()
}

export function genTime () {
  const year = new Date().getFullYear()
  var month = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ]
  var dateA = Array.from(
    { length: new Date().getMonth() },
    (value, index) => year + '-' + month[index]
  ).reverse()
  var dateB = Array.from(
    { length: 12 },
    (value, index) => year - 1 + '-' + month[index]
  ).reverse()
  var dateC = Array.from(
    { length: 12 },
    (value, index) => year - 2 + '-' + month[index]
  ).reverse()
  return dateA.concat(dateB).concat(dateC)
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js